import PropTypes from "prop-types";
import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import "./toast.scss";
import Icon from "../Icon";
import Button from "../Button";

const CheckIcon = (
  <Icon size="medium" name="system-checkmark" className="icon--checkmark" />
);

const CloseButton = ({ closeToast }) => {
  return (
    <Button
      className="button--icon-only toastify__close"
      onClick={closeToast}
      aria-label="Close toast"
    >
      <Icon name="system-close" className="toastify__close-icon" />
    </Button>
  );
};

CloseButton.propTypes = {
  closeToast: PropTypes.func,
};

const showToast = (message, toastId) => {
  toast(message, {
    toastId,
    autoClose: 2000,
  });
};

const showErrorToast = (message, toastId) => {
  toast.error(message, {
    toastId,
  });
};

const Toast = ({ delay, position }) => {
  return (
    <ToastContainer
      autoClose={delay}
      className="toastify"
      bodyClassName="toastify__toast-body"
      toastClassName="toastify__toast"
      hideProgressBar={true}
      icon={CheckIcon}
      position={position}
      closeButton={CloseButton}
      role="alert"
    />
  );
};

Toast.propTypes = {
  delay: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  position: PropTypes.string,
};

Toast.defaultProps = {
  delay: 5000,
  position: "top-center",
};

export default Toast;
export { showToast, showErrorToast };
